import React, { useState, useEffect } from "react";

export default function App() {
  const [time, setTime] = useState("07:30");
  const [days, setDays] = useState([]);
  const [schedules, setSchedules] = useState([]);

  const allDays = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];

  // Charger les horaires existants
  useEffect(() => { fetchSchedules(); }, []);

  async function fetchSchedules() {
    try {
      const response = await fetch("http://184.160.222.184:4000/schedules");
      const data = await response.json();
      setSchedules(data);
    } catch (err) { console.error(err); }
  }

  // 🔹 Démarrage immédiat
  async function startCar() {
    try {
      const response = await fetch("http://184.160.222.184:4000/voiture/start", {
        method: "POST",
        headers: { "Authorization": "Bearer monSuperToken123" }
      });
      const data = await response.json();
      alert(data.msg);
    } catch (err) {
      alert("Impossible de contacter le serveur : " + err.message);
    }
  }

  // 🔹 Arrêt immédiat
  async function stopCar() {
    if (!window.confirm("Voulez-vous vraiment arrêter le véhicule ?")) return;
    try {
      const response = await fetch("http://184.160.222.184:4000/voiture/stop", {
        method: "POST",
        headers: { "Authorization": "Bearer monSuperToken123" }
      });
      const data = await response.json();
      alert(data.msg || "Commande d'arrêt envoyée !");
    } catch (err) {
      alert("Impossible de contacter le serveur : " + err.message);
    }
  }

  // 🔹 Vérifier l'état de la voiture
  async function checkCarStatus() {
    try {
      const response = await fetch("http://184.160.222.184:4000/voiture/status", {
        method: "POST",
        headers: { "Authorization": "Bearer monSuperToken123" }
      });
      const data = await response.json();
      alert(data.msg || "Commande d'état envoyée !");
    } catch (err) {
      alert("Impossible de contacter le serveur : " + err.message);
    }
  }

  // 🔹 Ajouter un horaire
  async function submitSchedule(e) {
    e.preventDefault();
    if (days.length === 0) { alert("Sélectionne au moins un jour"); return; }

    try {
      const response = await fetch("http://184.160.222.184:4000/schedule", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ time, action: "start", days })
      });
      const data = await response.json();
      if (data.ok) {
        alert(`Horaire ajouté : ${time}`);
        setDays([]);
        fetchSchedules();
      } else alert("Erreur : " + data.msg);
    } catch (err) {
      alert("Impossible de contacter le serveur : " + err.message);
    }
  }

  // 🔹 Supprimer un horaire
  async function deleteSchedule(idx) {
    try {
      const response = await fetch(`http://184.160.222.184:4000/schedule/${idx}`, { method: "DELETE" });
      const data = await response.json();
      if (data.ok) fetchSchedules();
    } catch (err) {
      alert("Impossible de contacter le serveur : " + err.message);
    }
  }

  function toggleDay(day) {
    setDays(prev => prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]);
  }

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>Planifier un démarrage 🚗</h2>

      <form onSubmit={submitSchedule} style={{ marginBottom: "15px" }}>
        <label>Heure : </label>
        <input
          type="time"
          value={time}
          onChange={e => setTime(e.target.value)}
          style={{ marginRight: "10px" }}
        />

        <div style={{ margin: "10px 0" }}>
          {allDays.map(day => (
            <label key={day} style={{ marginRight: "8px" }}>
              <input
                type="checkbox"
                checked={days.includes(day)}
                onChange={() => toggleDay(day)}
              />
              {day}
            </label>
          ))}
        </div>

        <button type="submit">Planifier</button>
      </form>

      {/* 🔹 Boutons de contrôle espacés */}
      <div style={{
        marginBottom: "25px",
        display: "flex",
        gap: "15px",
        flexWrap: "wrap"
      }}>
        <button
          onClick={startCar}
          style={{
            background: "green",
            color: "white",
            padding: "10px 15px",
            borderRadius: "5px",
            border: "none",
            cursor: "pointer"
          }}
        >
          🚀 Démarrer Équinox EV
        </button>

        <button
          onClick={stopCar}
          style={{
            background: "red",
            color: "white",
            padding: "10px 15px",
            borderRadius: "5px",
            border: "none",
            cursor: "pointer"
          }}
        >
          🛑 Arrêter Équinox EV
        </button>

        <button
          onClick={checkCarStatus}
          style={{
            background: "dodgerblue",
            color: "white",
            padding: "10px 15px",
            borderRadius: "5px",
            border: "none",
            cursor: "pointer"
          }}
        >
          📡 État Équinox EV
        </button>
      </div>

      {/* 🔹 Liste des horaires */}
      <h3>📅 Horaires programmés :</h3>
      {schedules.length === 0 ? (
        <p>Aucun horaire pour l’instant.</p>
      ) : (
        <ul>
          {schedules.map((s, idx) => (
            <li key={idx}>
              {s.time} → {s.action} [{s.days.join(", ")}]{" "}
              <button onClick={() => deleteSchedule(idx)} style={{ marginLeft: "10px" }}>
                Supprimer
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
